import Loader from "react-loader-spinner";
import styled, { createGlobalStyle, css } from "styled-components";
import globalColours from "./colours";
import globalType from "./type";

const maxWidth = 656;

export const GlobalStyles = createGlobalStyle`
    .cursor-pointer {
        cursor: pointer;
    }

    html,
    body {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        background: ${globalColours.white};
        color: ${globalColours.black};
        ${globalType.body};
        letter-spacing: 0.15px;
        font-weight: 300;
        font-size: 16px;
    }

    h1, h2, h3 {
        font-size: 1rem;
        font-weight: 300;
        margin: 0;
    }

    b, strong {
        font-weight: 500;
    }

    * {
        -webkit-overflow-scrolling: touch;
        -webkit-font-smoothing: antialiased;
        box-sizing: border-box;
    }

    p:first-child {
		margin-top: 0;
	}

    /* Next Wrapper */

    #__next {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    /* Toast */

    .react-toast-notifications__container {
        &::-webkit-scrollbar {
            display: none;
        }
    }
`;

export const wrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  height: 100%;
`;

export const Heading = styled.div``;
export const Subheading = styled.div``;

export const container = css`
  display: flex;
  width: 100%;
  max-width: ${maxWidth}px;
`;

export const StyledLoader = styled(Loader).attrs({
  type: "TailSpin",
  color: globalColours?.accent7,
  height: 64,
  width: 64,
  className: "loader-spinner",
})`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${globalColours.white}77;

  svg {
    max-width: 60%;
    max-height: 60%;

    circle {
      fill: currentColor;
    }

    path {
      stroke: currentColor;
    }
  }
`;

export const hoverState = css`
  transition: 0.15s opacity ease;

  &:hover {
    opacity: 0.7;
  }
`;

export const padding = css`
  padding-left: 24px;
  padding-right: 24px;
  box-sizing: border-box;
`;

export const bgImage = css`
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
`;

export const bgIcon = css`
  background-size: contain;
  background-position: right center;
  background-repeat: no-repeat;
`;

export const dropdownIcon = css`
    &::after {
        content: '';
        background-image: url(${require("../assets/icons/select-arrow-small.svg")});
        position: absolute;
        top: 13px;
        right: 10px;
        width: 10px;
        height: 6px;
        ${bgIcon};
        pointer-events: none;
        transition: all 0.25s ease;e
    }
`;

export const dynamicFieldsStyles = `
    .dynamic-fields {
        flex-direction: row;
        flex-flow: row wrap;
        width: 100%;

        .dynamic-field {
            margin-bottom: 0;
            flex: 1;
            margin-left: -1px;
            margin-bottom: -1px;
            &:not(.takedown-disposal):not(.difficult-substrate) {
              border: 1px solid ${globalColours.accent2};
            }
            &:not(.returns) {
              margin-right: 8px;
            }
            max-height: 34px;

            input,
            textarea,
            textarea::placeholder,
            input::placeholder,
            .select__placeholder,
            .select__single-value,
            .select {
                ${globalType.small}
                border: 0;
                height: 32px !important;
                max-height: 32px !important;
                background: ${globalColours.white};
            }

            textarea {
                padding: 4px 8px 0;
                resize: none;
                border-bottom: 0;
                max-height: 32px !important;
                margin-top: 0;
                max-height: 32px !important;
                overflow: hidden;
            }

            input,
            textarea,
            .select__single-value,
            .select__placeholder {
                display: flex;
                align-items: center;
            }

            .select__single-value {
                width: 85%;
                color: ${globalColours.black};
            }

            .select__indicators {
                display: none;
            }

            input,
            .select__control,
            .select__value-container {
                min-height: 32px;
                height: 32px;
            }

            input,
            .select__single-value {
                padding-left: 12px;
            }

            .select__placeholder {
                padding-left: 12px !important;
            }
            .select__placeholder,
            .select__single-value,
            .select__input {
                position: absolute !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
                margin: 0 !important;
            }

            .select__value-container {
                height: 100% !important;
            }
            #room-fabric .select__placeholder,
            #window-fabric .select__placeholder, 
            #room-fabric-double .select__placeholder
            {
                padding-left: 0 !important;
            }

            .select__value-container {
                > * {
                    margin: 0;
                    padding: 0;
                }
            }

            .select__control {
                &::after {
                    border: 0;
                }
            }

            .select__menu {
                min-width: 260px;

                .select__option {
                    min-height: 28px;
                    padding: 4px 12px;

                    &, .select-label {
                        ${globalType.body}
                    }

                    /* background: ${globalColours.white}; */

                    &.select__option--is-focused  {
                        font-weight: 500;
                        background: ${globalColours.accent2};
                    }
                }
            }
        }
    }
`;

// Elevation

export const elevation = (level) => {
  const levels = {
    1: css`
      box-shadow:
        0px 1px 1px rgba(0, 0, 0, 0.25),
        0px 0px 1px rgba(0, 0, 0, 0.31);
    `,
    2: css`
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
    `,
    3: css`
      box-shadow:
        0px 8px 16px rgba(0, 0, 0, 0.25),
        0px 0px 1px rgba(0, 0, 0, 0.31);
    `,
    4: css`
      box-shadow:
        0px 12px 24px rgba(0, 0, 0, 0.25),
        0px 0px 1px rgba(0, 0, 0, 0.31);
    `,
    5: css`
      box-shadow:
        0px 20px 32px rgba(0, 0, 0, 0.25),
        0px 0px 1px rgba(0, 0, 0, 0.31);
    `,
  };

  return levels[level];
};

export const option = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${globalColours.accent1};
  padding: 0 8px;
  min-height: 34px;
  border-radius: 0;
  ${globalType.body};
  cursor: pointer;
  transition: background 0.1s ease;

  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const StyledText = styled.div`
  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `};

  ${({ $font }) =>
    !!$font &&
    css`
      ${$font};
    `};

  ${({ $bgColor }) =>
    $bgColor &&
    css`
      background-color: ${$bgColor};
    `};
`;

export const hideInputNumberArrows = (inputCssSelector) => {
  return `
    /* Chrome, Safari, Edge, Opera */
    ${inputCssSelector}::-webkit-outer-spin-button,
    ${inputCssSelector}::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
      display: none;
    }

    /* Firefox */
    ${inputCssSelector} {
      -moz-appearance: textfield;
    }
  `;
};

// Re-export colours & type

export const colours = globalColours;
export const type = globalType;
